const BuildingsLayerIcon = () => {
	const iconStyles = `
    .icon_ct {
      fill: none;
      stroke: currentColor;
      stroke-width: 1;
      pointer-events: none;
    }
    .icon_bg {
      fill:rgba(0, 0, 0, 0);
      stroke: currentColor;
      stroke-width: 1;
    }
    .icon_bg:hover {
      fill: currentColor;
      stroke: var(--color-primary);
    }
    `;

	return (
		<svg viewBox={`0 0 100 100`} width={'100%'} height={'100%'}>
			<style>{iconStyles}</style>
			<path 
        className="icon_bg" 
        d="M14 29v42l36 21 36 -21v-42l-36 -21z" />
			<path
				className="icon_ct"
				d="M50 50l36 -21 M14 29l36 21 M50 92v-42 M50 50l-36 -21 M50 50v42 M86 29l-36 21 "
			/>
		</svg>
	);
};

export default BuildingsLayerIcon;
